import { useEffect, useState } from "react";
import { formatDistanceToNow } from "date-fns";

export function RelativeTime({
  iso,
  fallback = "—",
}: {
  iso: string | null | undefined;
  fallback?: string;
}) {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!iso) return;
    const t = setInterval(() => setTick((n) => n + 1), 30_000);
    return () => clearInterval(t);
  }, [iso]);

  if (!iso) return <span className="text-muted">{fallback}</span>;
  const date = new Date(iso);
  return (
    <time dateTime={iso} title={date.toISOString()} className="tabular-nums">
      {formatDistanceToNow(date, { addSuffix: true })}
    </time>
  );
}
